export default "__VITE_ASSET__DmWGlkEO__"